import React, { useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from './Loading';

import FileUploadField from '../Components/FileUploadField';

export const AddNewSignatureComponent = ({ userId, onReloadContent }) => {
    const { openTimeModal } = useTimeModal();
    const location = useLocation();
    const navigate = useNavigate();
    const sigCanvas = useRef(null);
    
    const [loading, setLoading] = React.useState(false);
    const [reload, setReload] = React.useState(true);

    const [typeSelector, setTypeSelector] = React.useState('SelfDraw');

    const handleAddNewSignature = () => {
        if (!sigCanvas.current) return;

        setLoading(true);
        const token = localStorage.getItem('token');

        // Получаем base64-строку
        const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');

        // Преобразуем base64 → Blob
        const byteString = atob(dataURL.split(',')[1]);
        const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeString });

        // Создаём FormData
        const formData = new FormData();
        formData.append('user_id', userId ?? '');
        formData.append('signature', blob, 'signature.png');

        axios.put('/api/save-user-signature', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        })
        .then(() => {
            if (location.pathname.startsWith('/essential-data')) {
                navigate('/home');
            } else {
                openTimeModal('Подпись сохранена', 'success');
                onReloadContent();
            }
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setReload(true);
            setLoading(false);
        });
    };

    const handleClear = () => {
        sigCanvas.current.clear();
    };



    const handleUploadNewSignature = () => {
        setLoading(true);
        const token = localStorage.getItem('token');

        const formData = new FormData();
        formData.append('user_id', userId ?? '');
        formData.append('signature', files.signatureFile);

        axios.put('/api/save-user-signature', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        })
        .then(() => {
            if (location.pathname.startsWith('/essential-data')) {
                navigate('/home');
            } else {
                openTimeModal('Подпись сохранена', 'success');
                onReloadContent();
            }
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setReload(true);
            setLoading(false);
        });
    };

    
    const [files, setFiles] = React.useState({
        signatureFile: null,
    });
    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
          ...prev,
          [field]: file || null,
        }));
    };
    
    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
          ...prev,
          [field]: null,
        }));
    };



    return (
        <div className='panel'>
            <div className='panelHeader'>
                <h3>Внесите свою подпись</h3>
            </div>
            <div className='panelMain'>
            <div className='radioSwitchWrapper'>
                <label className={`radioSwitchLabel ${typeSelector === 'SelfDraw' ? 'selected' : ''}`}>
                <input
                    type='radio'
                    name='typeSelector'
                    value='SelfDraw'
                    checked={typeSelector === 'SelfDraw'}
                    onChange={() => setTypeSelector('SelfDraw')}
                />
                <span>Ввести подпись вручную</span>
                </label>
                <label className={`radioSwitchLabel ${typeSelector === 'Upload' ? 'selected' : ''}`}>
                <input
                    type='radio'
                    name='typeSelector'
                    value='Upload'
                    checked={typeSelector === 'Upload'}
                    onChange={() => setTypeSelector('Upload')}
                />
                <span>Загрузить скан подписи</span>
                </label>
            </div>
            {typeSelector==='SelfDraw' &&
            <div className='horizontalContainer withSwapIfScreenWidthSmall'>
                <p className='description'>Разместите подпись внутри области, заполняя её целиком</p>
                <SignatureCanvas
                    ref={sigCanvas}
                    penColor="black"
                    minWidth={1}
                    maxWidth={2}
                    velocityFilterWeight={1}
                    canvasProps={{ width: 420, height: 200, className: 'sigCanvas', style: { border: '1px solid #b9b9b9ff', borderRadius: '5px' } }}
                />
            </div>}
            {typeSelector==='Upload' &&
            <>
                <FileUploadField
                    label='Добавить файл'
                    file={files.signatureFile}
                    buttonLabel='Добавить файл'
                    onChange={handleFileChange('signatureFile')}
                    onReset={handleFileReset('signatureFile')}
                    allowedFileTypes={['png', 'jpg', 'jpeg']}
                    isAlreadyOpened={true}
                    isCloseButton={false}
                />
                <p className='description'>Подпись должна быть четкой и хорошо видимой на белом фоне без видимых границ</p>
            </>}
            </div>
            <div className='panelBottom'>
                <div></div>
                {typeSelector==='SelfDraw' &&
                (loading ? 
                    <Loading type='inline' />
                :
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button 
                    onClick={handleClear} 
                    className='button optionalButton'
                    >
                    Очистить
                    </button>

                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleAddNewSignature}
                    disabled={loading}
                    >
                        Сохранить
                    </button>
                </div>
                )}
                {typeSelector==='Upload' &&
                (loading ? 
                    <Loading type='inline' />
                :
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleUploadNewSignature}
                    disabled={loading}
                    >
                        Отправить
                    </button>
                </div>
                )}
            </div>
        </div>
    )
}
